<template>
<v-container fluid>
    <v-row no-gutters>
        <v-col cols="12">
            <v-card>
              <v-card-title>
               Supplier failure codes
              </v-card-title>
              <v-card class="primary rounded-circle" width="300" height="300">
               pie
              </v-card>
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>


<script>
export default {
name: 'ServiceVolumeGraph',
props: [],
data() {
  return {};
},

methods: {},

computed: {},

watch: {},
};
</script>


<style lang='scss' scoped>
</style>